module.exports = __webpack_public_path__ + "static/img/brees-2006-img-in-copy.6094446.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2006-img-in-copy.jpg
// module id = 1r/+
// module chunks = 1